import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AumicoCoreProvider } from '@modeso/aumico-lib-core-fe';
import { UsersConfig, UsersConfigService } from '@modeso/aumico-lib-users-fe';
import { Observable } from 'rxjs';
import { CreateAnnotationDto } from '../dtos/create-annotation-dto.interface';
import { GetTaskAnnotationsDto } from '../dtos/get-task-annotations-dto.interface';
import { UpdateAnnotationDto } from '../dtos/update-annotation-dto.interface';
import { Annotation } from '../interfaces/annotation.interface';
import { RoutesUtil } from '../util/RoutesUtil';

@Injectable({
    providedIn: 'root',
})
export class AnnotationsService {
    constructor(
        private http: HttpClient,
        @Inject(UsersConfigService) config: UsersConfig,
        private readonly coreProvider: AumicoCoreProvider,
        private routesUtil: RoutesUtil,
    ) {}

    public createAnnotation(taskId: string, createAnnotationDto: CreateAnnotationDto): Observable<Annotation> {
        const url = this.routesUtil.createAnnotation(taskId);
        return this.http.post<Annotation>(url, createAnnotationDto).pipe();
    }

    public updateAnnotation(annotationId: string, updateAnnotationDto: UpdateAnnotationDto): Observable<Annotation> {
        const url = this.routesUtil.updateAnnotation(annotationId);

        return this.http.put<Annotation>(url, updateAnnotationDto).pipe();
    }

    public deleteAnnotation(annotationId: string): Observable<void> {
        const url = this.routesUtil.deleteAnnotation(annotationId);

        return this.http.delete<void>(url).pipe();
    }

    public getTaskAnnotations(taskId: string, page: number = 1, limit: number = 50): Observable<GetTaskAnnotationsDto> {
        const url = this.routesUtil.getTaskAnnotations(taskId);
        let params = new HttpParams().set('page', page.toString()).set('limit', limit.toString());

        return this.http.get<GetTaskAnnotationsDto>(url, { params }).pipe();
    }
}
